import { SunIcon } from "@phosphor-icons/react/dist/csr/Sun";
import { FlowerLotusIcon } from "@phosphor-icons/react/dist/csr/FlowerLotus";
import { CalendarDotsIcon } from "@phosphor-icons/react/dist/csr/CalendarDots";
import { DatabaseIcon } from "@phosphor-icons/react/dist/csr/Database";

export const SETTINGS_SECTIONS = [
  { id: "appearance", label: "Appearance", icon: <SunIcon size={22} /> },
  { id: "categories", label: "Categories", icon: <FlowerLotusIcon size={22} /> },
  { id: "tracking", label: "Tracking", icon: <CalendarDotsIcon size={22} /> },
  { id: "data", label: "Data", icon: <DatabaseIcon size={22} /> },
];
export function getSettingsSection(search: string) {
  const value = new URLSearchParams(search).get("section");
  return SETTINGS_SECTIONS.find((section) => section.id === value)?.id ?? "appearance";
}
export const settingsHref = (id: string) => `/settings?section=${id}`;
